
export default {
  name: 'icon-facebook',
};
